import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import {
  Button,
  Input,
  InputIcon,
  Modal,
  VerticalNavigation
} from '@salesforce/design-system-react';

import { ECSAssetPicker } from '../';
import { ContentBuilderList } from '../../../ecs/components';
import './ImageImportModal.scss';

class ImageImportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      imageType: 'contentBuilder',
      imageUrl: ''
    };
    this.modalName = 'imageImport';
  }

  componentDidMount() {
    if (!this.props.assets?.data?.search?.experiments?.assets?.length) {
      //this.props.actions.searchAssets({}, {}, { context: 'experiments' });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(prevProps, this.props, 'modals.imageImport.isOpen', true)
    ) {
      this.props.actions.searchContentBuilder();
    }
  }

  handleContentSelect(event, selection) {
    const selectedAsset = selection.selection[0];
    if (!selectedAsset.disabled) {
      this.props.actions.updateModal(this.modalName, { selectedAsset });
    }
  }

  handleSelect() {
    const selectedAsset = this.props.modals[this.modalName]?.data
      ?.selectedAsset;
    if (selectedAsset && this.state.imageType === 'contentBuilder') {
      this.props.onContentBuilderSelect(selectedAsset);
    } else if (
      this.state.imageUrl.length &&
      this.state.imageType === 'imageUrl'
    ) {
      this.props.onUrlSelect(this.state.imageUrl);
      this.setState({ imageUrl: '' });
    } else if (selectedAsset.asset_class_id.length) {
      this.props.onECSAssetSelect(selectedAsset);
    }
    this.props.actions.closeModal(this.modalName);
  }

  handleEcsContentSelect(selection) {
    const selectedAsset = selection[0];
    if (!selectedAsset.disabled) {
      this.props.actions.updateModal(this.modalName, { selectedAsset });
    }
  }

  renderFromECS() {
    return (
      <div className="slds-col slds-size_5-of-7">
        <ECSAssetPicker
          actions={this.props.actions}
          assets={this.props.assets}
          onRowSelect={selection => this.handleEcsContentSelect(selection)}
          context="experiments"
          selectable
        />
      </div>
    );
  }

  renderContentBuilder() {
    const selectedAsset = this.props.modals[this.modalName]?.data
      ?.selectedAsset;
    return (
      <div className="slds-col slds-size_5-of-7">
        <ContentBuilderList
          actions={this.props.actions}
          contentBuilder={this.props.contentBuilder}
          rowSelectionMode="radio"
          onContentSelect={this.handleContentSelect.bind(this)}
          selectedContent={selectedAsset}
        />
      </div>
    );
  }

  renderImageUrl() {
    const { formatMessage } = this.props.intl;
    const label = formatMessage({ id: 'components.ecs.imageURLModal.info' });
    const imagePlaceholder = formatMessage({
      id: 'components.ecs.imageURLModal.placeholder'
    });

    const clearButton = (
      <InputIcon
        assistiveText={{
          icon: 'Clear'
        }}
        name="clear"
        category="utility"
        onClick={event => {
          this.setState({ imageUrl: '' });
        }}
      />
    );

    return (
      <Input
        key={`image-url-field`}
        className="field-input"
        value={this.state.imageUrl}
        label={label}
        //errorText={data.errorText}
        //onBlur={onBlur}
        onChange={(event, data) => {
          this.setState({ imageUrl: data.value });
        }}
        placeholder={imagePlaceholder}
        iconRight={this.state.imageUrl ? clearButton : null}
      />
    );
  }

  renderAddUrlButton() {
    const { formatMessage } = this.props.intl;
    return (
      <Button
        className="image-add-url-button"
        label={formatMessage({
          id: this.getI18nID('actionButtons.addURL')
        })}
        disabled={this.props.canAddRule}
        iconCategory="utility"
        iconName="add"
        iconPosition="left"
        onClick={this.props.onAddRule}
      />
    );
  }

  renderFooter() {
    const { formatMessage } = this.props.intl;

    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: this.getI18nID('actionButtons.cancel')
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Select
     */
    const selectLabel = formatMessage({
      id: this.getI18nID(`actionButtons.select`)
    });
    const selectButton = (
      <Button
        label={selectLabel}
        disabled={
          !this.props.modals[this.modalName]?.data?.selectedAsset &&
          !this.state.imageUrl
        }
        variant="brand"
        onClick={this.handleSelect.bind(this)}
      />
    );

    return (
      <div className="footer-button-actions">
        {cancelButton}
        {selectButton}
      </div>
    );
  }

  getI18nID(suffix) {
    return `components.experiment.imageImportModal.${suffix}`;
  }

  closeModal() {
    this.props.actions.clearContentBuilderSearch();
    this.props.actions.closeModal(this.modalName);
  }

  renderImportTypeOptions() {
    const { formatMessage } = this.props.intl;
    const imageTypes = [
      {
        id: 'imageType',
        items: [
          {
            id: 'contentBuilder',
            label: formatMessage({ id: this.getI18nID('contentBuilder') })
          },
          {
            id: 'imageUrl',
            label: formatMessage({ id: this.getI18nID('imageUrl') })
          },
          {
            id: 'fromECS',
            label: formatMessage({ id: this.getI18nID('fromECS') })
          }
        ]
      }
    ];
    return (
      <div className="image-type slds-col slds-size_2-of-7">
        <VerticalNavigation
          id="experiment-imageType"
          categories={imageTypes}
          selectedId={this.state.imageType}
          onSelect={(evt, data) => this.setState({ imageType: data.item.id })}
        />
      </div>
    );
  }

  renderImportType() {
    if (this.state.imageType === 'contentBuilder') {
      return this.renderContentBuilder();
    } else if (this.state.imageType === 'imageUrl') {
      return (
        <div className="image-url slds-col slds-size_5-of-7">
          {this.renderImageUrl()}
        </div>
      );
    } else if (this.state.imageType === 'fromECS') {
      return this.renderFromECS();
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen = this.props.modals[this.modalName]?.isOpen;
    const modalTitle = formatMessage({
      id: this.getI18nID('title')
    });

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        containerClassName="experiment-image-type"
        contentClassName="experiment-image-content"
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        disableClose={true}
        isOpen={isOpen || false}
      >
        <div className="experiment-image-container slds-grid">
          {this.renderImportTypeOptions()}
          {this.renderImportType()}
        </div>
      </Modal>
    );
  }
}

ImageImportModal.propTypes = {
  actions: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  contentBuilder: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  onUrlSelect: PropTypes.func.isRequired,
  onECSAssetSelect: PropTypes.func.isRequired,
  onContentBuilderSelect: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ImageImportModal);
